import React, { Component } from 'react';
import axios from '../services/AxiosOrders'
import {MyStore} from '../services/Store'
import {Reducer} from './Reducer'
// import  { firebase, googleAuthProvider, database, MyStore } from '../app/utilites/Store'
// const Context = React.createContext();



const Context = React.createContext({
    files: [],
    fetchFiles: () => {},
    // registerUser: () => {},
    // deleteUser: () => {},
    isLoading: false
  });

export class Provider extends Component {
    constructor(){
      super()
      this.state = {
        user:{},
        fetchUsers: this.fetchUsers,
        projectData:{},
        myFiles:[],
        logs:[],
        cards: [],
        cardsId:null,
        auth: { token: null, localId: null, expDate: null },
        dispatch: action => {
          this.setState(state => Reducer(state, action));
        }
      };
        this.database=MyStore.database().ref();
        this.authStateListner() 
  }


  


//   authState, firebase, googleAuthProvider, database


  authStateListner=()=>{
    MyStore.auth().onAuthStateChanged((user)=>{
             if(user){
                 this.setState({user:user});

                //  this.database.child(this.state.user.uid).child("files").on('value',snap=>{

                // //  this.database.child(this.state.user.uid).child("cards").child('-LsiBMcthS-QExzFJMSg').child('files').on('value',snap=>{
                //     //console.log(snap.val())
                //     let myArr=[]
        
                //     // console.log(snap.val())
                //     // for(const key in snap.val()){
                //     //     myArr.push(Object.assign({},snap.val()[key].metadataFile,{key:key}));
                //     //     console.log(snap.val()[key].metadataFile);
                //     // }


                //     for(const key in snap.val()){
                //         myArr.push(Object.assign({},snap.val()[key]));
                //         // console.log(snap.val()[key]);

                //     }


                //     if(snap.val()!=null){
                //         this.setState({
                //             myFiles:myArr
                //         })
                //     }
                //     else{
                //         this.setState({
                //             myFiles:[]
                //         })
                //     }
                   
                //  });
                 
                //  this.database.child(this.state.user.uid).child("log").on('value',snap=>{
                //     //console.log(snap.val())
                //     let myArr=[]
        
                //     // console.log(snap.val())
                //     for(const key in snap.val()){
                //         myArr.push(snap.val()[key].action);
                //        // console.log(snap.val()[key].metadataFile);
                //     }


        
                //     if(snap.val()!=null){
                //         this.setState({
                //             logs:myArr
                //         })
                //     }
                //     else{
                //         this.setState({
                //             logs:[]
                //         })
                //     }
                   
                //  });
             }
             else{
                 this.setState({user:null,todos:[]})
             }
         })
      }
      

     componentDidMount() {
        //  console.log(' props.match.params.id;')
        //  console.log(this.props.match)
        const auth = {
            token: localStorage.getItem('token'),
            localId: localStorage.getItem('userId'),
            expDate: new Date(localStorage.getItem('expDate'))
        };

        if (auth.expDate < new Date()) {
            auth.token = null;
        }

        // const queryParams = `?auth=${auth.token}&orderBy="userId"&equalTo="${auth.localId}"`;
        


    // let resp = await axios.post(`/${localId}/cards.json?auth=${token}`, this.newCard);

    // let resp = await axios.post(`/groups/${this.props.oid}/cards.json?auth=${token}`, this.newCard);

            
        if (auth.token !== null) {
            // console.log('inside if statement')
            // console.log(auth.localId)

            // const resp =  axios.get(`${auth.localId}/cards.json?auth=${auth.token}`);

            const resp =  axios.get(`/groups/${this.props.oid}/cards.json?auth=${auth.token}`);

            // const resp = await axios.get(`${auth.localId}/cards.json${queryParams}`);
            // const resp = await axios.get(`/cards.json${queryParams}`);

            this.authStateListner()


            // this.getCardsId(resp, auth)
            this.refreshCards(resp, auth);

        }
        // const resp = await axios.get(`/cards.json${queryParams}`);
        // this.refreshCards(resp, auth);
    }

    fetchFiles = async () => {
        // this.setLoading(true);
    
        let files = await this._getFiles();
        // console.log('--------------files---line 153 Context')
        // console.log(files)
        this.setState({
          files,
          isLoading: false
        });
      };
      _getFiles(){
        const auth = {
            token: localStorage.getItem('token'),
            localId: localStorage.getItem('userId'),
            expDate: new Date(localStorage.getItem('expDate'))
        };
        let resp = ''
        resp =  axios.get(`${auth.localId}/cards.json?auth=${auth.token}`);
        // console.log('-----------------resp---------------------- line 46')
        // console.log(resp)
        return resp
    }


    getCardsId = (resp, auth) => {
        // let id = null;
        // for (let key in resp.data) {
        //     fetchedOrders.push({
        //         id: key,
        //         ...resp.data[key]
        //     });
        // }
        // console.log("resposnse data id")
        // console.log(resp.data.id)
        this.setState({ auth, cardsId: resp.data.id});
    }

    refreshCards = async (resp, auth) => {
        const fetchedOrders = [];
        for (let key in resp.data) {
            fetchedOrders.push({
                id: key,
                ...resp.data[key]
            });
        }
        this.setState({ auth, cards: fetchedOrders });
        // console.log('line 182')
        // console.log(this.state.cards)
    };

    render() {
        return (
            <Context.Provider value={this.state}>
                {this.props.children}
            </Context.Provider>
        );
    }
}

export const MyContext = Context;

export const Consumer = Context.Consumer;
